const { countBy } = require("lodash");

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

Date.prototype.toDisplay = function() {
    var date = new Date(this.valueOf());
    return $.datepicker.formatDate(date_format, date);
}

function date_db_to_display(d){
    if(!d){
        return '';
    }
    let d_chunks=d.split('-');
    d_chunks['yy']=d_chunks[0];
    d_chunks['mm']=d_chunks[1];
    d_chunks['dd']=d_chunks[2];

    let f_date=date_format;
    f_date=f_date.replace('yy',d_chunks['yy']);
    f_date=f_date.replace('mm',d_chunks['mm']);
    f_date=f_date.replace('dd',d_chunks['dd']);

    return f_date;

}
window.date_db_to_display=date_db_to_display;


////////////////////////////////////////////


function load_loader_image(img){
    $(img).removeClass('not-loaded').addClass('loading').attr('src',$(img).data('src'));
}
window.load_loader_image=load_loader_image;
function load_loader_images(wrapper){

    wrapper.find('.loader-image').bind('load',function(){

        // console.log('loaded... ',$(this).attr('src'));

        if($(this).hasClass('loading')){
            $(this).removeClass('loading').addClass('loaded');

            let images=wrapper.find('.loader-image.not-loaded');
            if(images.length){
                // console.log('load next ',images[0]);
                $(images[0]).removeClass('not-loaded').addClass('loading').attr('src',$(images[0]).data('src'));
            }

        }
        
    });

    let images = wrapper.find('.loader-image.not-loaded');

    for(let i=0;i<images.length;i++){
        // console.log('i',i);
        $(images[i]).removeClass('not-loaded').addClass('loading').attr('src',$(images[i]).data('src'));
        if(i>=2){   //2 at time
            break;
        }
    }

}
window.load_loader_images=load_loader_images;

////////////////////////////////////////////

function block_ui(){
    $.blockUI({ message: null, 
        baseZ: 999999, css:{ zIndex:'999999'} }); 
}
window.block_ui=block_ui;


function unblock_ui(){
    $.unblockUI();
}
window.unblock_ui=unblock_ui;

/////////////////////////////////////////////

function success_color_animate(element){
	// let color = element.css( "background-color" );
    // console.log(color);
	// // element.css("background-color","#66FF66");
	// element.animate({
    //         backgroundColor: "#66FF66"
    //         // backgroundColor: "transparent"
    //     }, 2000,function() {
    //         alert('done');
    //         let color = element.css( "background-color" );
    // console.log(color);
    //       } );

        
}
window.success_color_animate=success_color_animate;


function error_color_animate(element){
	
	// element.css("background-color","#FF6666");
	// element.animate({
    //         backgroundColor: "transparent"
    //     }, 2000 );
}
window.error_color_animate=error_color_animate;

////////////////////////////////////////////////////

function confirm_delete(form_id, dialog_text){

    console.log('Delete form_id',form_id);
    if(typeof dialog_text ==='undefined'){
        dialog_text="Are you sure?";
    }

    bootbox.confirm({ 
        size: "small",
        message: dialog_text,
        callback: function(result){ 
            if(result){
                document.getElementById(form_id).submit();
            }
        }
    
    })
     return false;
}
window.confirm_delete=confirm_delete;

/////////////////////////////////////////////////////

$(function() {

    $('.auto-modal-trigger').on('click',modal_trigger_click);

    set_form($('body'));    //for inline forms

    set_single_edits();

    $('[data-toggle="tooltip"]').tooltip();

    set_responsive_table_auto_title();


    $('#first-block-ui').remove();

    $('.bb-alert-not-available').on('click',function(){ bootbox.alert('Currently not available'); return false;});
        
});

function set_responsive_table_auto_title(){
    $('.responsive-table.auto-title').each(function(){
			
        let table=$(this);
        let titles=[];
        let td_index=0;
        table.find('thead tr th').each(function(){
            titles.push($(this).text());
            // titles.push($(this).html());
            let cs=parseInt($(this).attr('colspan'));
            for(let i=0;i<cs;i++){
                titles.push('');
            }
        });
        
        
        
        table.find('tbody tr').each(function(){
            let tr=$(this);
            let i=0;
            
            console.log(tr);
            
            tr.find('td').each(function(){
                //$(this).data('title',titles[i]);	//ovo se ne sprema kao html attribut
                $(this).attr('data-title',titles[i]);
                
                i++;
            });
            
            for(let i=0; i<titles.length;i++){
                
            }
        });
        
    });
}

function set_textarea_autosized(element){
    element.find("textarea.textarea-autosize").each(function () {
        let h=this.scrollHeight;
        if(h==0){
            h=$(this).val().split("\n").length*23;
        }
        if(h<23){
            h=23;
        }
        this.setAttribute("style", "height:" + (h) + "px;overflow-y:hidden;");
    }).on("input", function () {
        this.style.height = 0;
        this.style.height = (this.scrollHeight) + "px";
    });
}

function set_form(element){
    // set_datepickers(element)
    set_datepickers(element);
    set_currency_inputs(element);
    set_number_inputs(element);
    set_percentage_inputs(element);
    set_wysiwyg_editors(element);
    set_autocomplete_inputs(element);
    set_textarea_autosized(element);

    if(element.prop('tagName')=='BODY'){
        $('form.save-on-change').on('change', '.form-control', save_on_change);
    }else if(element.hasClass('save-on-change')){
        element.on('change', '.form-control', save_on_change);
    }
    

}
window.set_form=set_form;



function set_datepickers(element){

    element.find('.from-to-date-block').each(function(){

        set_datepicker_range(this);
        
    });

    element.find('.single-date-block').each(function(){

        set_datepicker(this);
        
    });
}
window.set_datepickers=set_datepickers;

function set_datepicker(element){
    let date_format="dd.mm.yy";
    let _this=element;
    let dp=$(_this).find('.single-date').datepicker({
        dateFormat: date_format,
        altField: $(_this).find('.single-date-alt'),
        altFormat: "yy-mm-dd",
        // minDate: '01.01.'+active_year,
        // maxDate: '31.12.'+active_year,
        changeMonth: true,
        changeYear: true,
        numberOfMonths:2,
        onSelect: function(string_date,element){
        
            $(this).trigger('change');

        },
        onClose: function(){
            $(this).trigger('change');
        }
    });

    if($(_this).find('.single-date-alt').val()){
        dp.datepicker('setDate', new Date($(_this).find('.single-date-alt').val()));
    }
}
window.set_datepicker=set_datepicker;

function set_datepicker_range(element){

    let date_format="dd.mm.yy";
    let _this=element;
    
    let dp_from=$(_this).find('.from-date').datepicker({
        dateFormat: date_format,
        altField: $(_this).find('.from-date-alt'),
        altFormat: "yy-mm-dd",
        minDate: '01.01.'+active_year,
        maxDate: '31.12.'+active_year,
        changeMonth: true,
        numberOfMonths:2,
        firstDay:6, //subota
        onSelect: function(string_date, element){
            console.log('from date selected',$(this),element);
            let d=$.datepicker.parseDate( date_format, string_date );
            // console.log(d);
            d=d.addDays(1);
            // console.log(d);
            $(_this).find('.to-date').datepicker( "option", "minDate",d);
            setTimeout(function(){ $(_this).find('.to-date').trigger('focus'); },500);

            $(this).trigger('change');
        },
        // beforeShowDay: function(d) {

        //     if(!$(_this).find('.from-date-alt').val() || !$(_this).find('.to-date-alt').val()){
        //         return [true, ''];
        //     }

        //     let a=$.datepicker.parseDate( date_format, $(_this).find('.from-date-alt').val());
        //     let b=$.datepicker.parseDate( date_format, $(_this).find('.to-date-alt').val());
            
        //     return [true, (a <= d && d <= b ? "selected-period" : "")];
        // }
    });

    let dp_to = $(_this).find('.to-date').datepicker({
        dateFormat: date_format,
        altField: $(_this).find('.to-date-alt'),
        altFormat: "yy-mm-dd",
        minDate: '02.01.'+active_year,
        maxDate: '31.12.'+active_year,
        changeMonth: true,
        numberOfMonths:2,
        firstDay:6, //subota
        onSelect:function(string_date,element){
            console.log('to date selected',$(this),element);

            $(this).trigger('change');
        },
        // beforeShowDay: function(d) {
        //     if(!$(_this).find('.from-date-alt').val() || !$(_this).find('.to-date-alt').val()){
        //         return [true, ''];
        //     }
        //     let a=$.datepicker.parseDate( date_format, $(_this).find('.from-date-alt').val());
        //     let b=$.datepicker.parseDate( date_format, $(_this).find('.to-date-alt').val());
            
        //     return [true, (a <= d && d <= b ? "selected-period" : "")];
        // }
    });

    if($(_this).find('.to-date-alt').val()){
        dp_to.datepicker('setDate', new Date($(_this).find('.to-date-alt').val()));
    }
    
    if($(_this).find('.from-date-alt').val()){
        dp_from.datepicker('setDate',new Date($(_this).find('.from-date-alt').val()));
        let d=new Date($(_this).find('.from-date-alt').val());
        d=d.addDays(1);
        dp_to.datepicker( "option", "minDate",d);
    }
    

}
window.set_datepicker_range=set_datepicker_range;


function set_percentage_inputs(element){

    element.find('input.percentage').each(function(){
        set_percentage_input($(this)[0]);

        $(this).on('focus',function(){
            this.select();
        });
    });

    // element.find('input.percentage-decimal').each(function(){
    //     set_percentage_decimal_input($(this)[0]);
    // });
    
}
window.set_percentage_inputs=set_percentage_inputs;

function set_percentage_input(element){
    
    let auto_numeric_options = {
        digitGroupSeparator        : '.',
        decimalCharacter           : ',',
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        decimalPlaces              : 0,
        unformatOnSubmit           : true,
        modifyValueOnWheel         : false,
        maximumValue               : 100,

        currencySymbol             : ' %',
        currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
    
    };
    return new AutoNumeric(element, auto_numeric_options);
    // new AutoNumeric('input.percentage', auto_numeric_options);

}
window.set_percentage_input=set_percentage_input;



function set_currency_inputs(element){

    element.find('input.currency').each(function(){
        set_currency_input($(this)[0]);

        $(this).on('focus',function(){
            this.select();
        });
    });

    element.find('input.currency-decimal').each(function(){
        set_currency_decimal_input($(this)[0]);
    });
    
}
window.set_currency_inputs=set_currency_inputs;

function set_currency_input(element){
    
    let auto_numeric_options = {
        digitGroupSeparator        : '.',
        decimalCharacter           : ',',
        // decimalCharacterAlternative: '.',
        currencySymbol             : ' €',
        currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        decimalPlaces              : 0,
        unformatOnSubmit           : true,
        modifyValueOnWheel         : false
    
    };
    let an=new AutoNumeric(element, auto_numeric_options);
    // new AutoNumeric('input.currency', auto_numeric_options);
    if(element.value==''){
        an.set(0);
    }

    return an;
}
window.set_currency_input=set_currency_input;

function set_currency_decimal_input(element){
    
    let auto_numeric_options = {
        digitGroupSeparator        : '.',
        decimalCharacter           : ',',
        // decimalCharacterAlternative: '.',
        currencySymbol             : ' €',
        currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        // decimalPlaces              : 0,
        unformatOnSubmit           : true,
        modifyValueOnWheel         : false
    
    };
    let an=new AutoNumeric(element, auto_numeric_options);
    // new AutoNumeric('input.currency', auto_numeric_options);
    if(element.value==''){
        an.set(0.0);
    }
    return an;
}
window.set_currency_decimal_input=set_currency_decimal_input;


function set_number_inputs(element){

    element.find('input.integer').each(function(){
        set_integer_input($(this)[0]);

        $(this).on('focus',function(){
            this.select();
        });
    });

    element.find('input.decimal').each(function(){
        set_decimal_input($(this)[0]);
    });
    
}
window.set_number_inputs=set_number_inputs;

function set_integer_input(element){
    
    let auto_numeric_options = {
        digitGroupSeparator        : '.',
        decimalCharacter           : ',',
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        decimalPlaces              : 0,
        unformatOnSubmit           : true,
        modifyValueOnWheel         : false
    
    };
    let an=new AutoNumeric(element, auto_numeric_options);
    // new AutoNumeric('input.currency', auto_numeric_options);
    if(element.value==''){
        an.set(0);
    }

    return an;
}
window.set_integer_input=set_integer_input;

function set_decimal_input(element){
    
    let auto_numeric_options = {
        digitGroupSeparator        : '.',
        decimalCharacter           : ',',
        currencySymbolPlacement    : AutoNumeric.options.currencySymbolPlacement.suffix,
        roundingMethod             : AutoNumeric.options.roundingMethod.halfUpSymmetric,
        unformatOnSubmit           : true,
        modifyValueOnWheel         : false
    
    };
    let an=new AutoNumeric(element, auto_numeric_options);
    // new AutoNumeric('input.currency', auto_numeric_options);
    if(element.value==''){
        an.set(0.0);
    }
    return an;
}
window.set_decimal_input=set_decimal_input;

function set_wysiwyg_editors(element){
    // element.find('textarea.wysiwyg').each(function(){
       
       

    // }); 
    
    tinymce.init({
        selector: 'textarea.wysiwyg', 
        plugins: 'code table lists paste',
        toolbar: 'undo redo | formatselect| bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | code | table | pastetext',
        force_br_newlines : true,
        force_p_newlines : false,
        forced_root_block : '', // Needed for 3.x

        //https://www.tiny.cloud/docs-4x/configure/editor-appearance/#menubar
        statusbar: false,
        menubar: false,


        paste_as_text: true, // Makes the pastetext active when the editor loads


        content_style: `
            body {
                font-family:Trebuchet MS,Tahoma,Verdana,Arial,sans-serif;
                background: #fff;
                font-size: .8rem;
                margin:6px;
            }
        
        `,


       
        // height:editor_height,

        setup: function(editor) {

            let editor_height=$(editor.getElement()).data('editor_height');
            if(editor_height){
                editor.settings.height=editor_height;
            }

            // console.log(editor.getElement());
            // editor.settings.height=800;

            // console.log(editor);
            // console.log(editor.height);
            
            // editor.on('init', function(e) {
            //   console.log('The Editor has initialized.');
            // });
            // editor.on('change', function(e) {
            //     console.log('The Editor has changed.');
            // });
            editor.on('blur', function(e) {
                // console.log('The Editor has lost focus.', editor.getBody().innerHTML);
                let ta=editor.getElement();
                $(ta).html(editor.getBody().innerHTML).trigger('change');
            });
          }

        //https://www.tiny.cloud/docs-3x/reference/Configuration3x/Configuration3x@onchange_callback/
        // onchange_callback: function (inst){
        //     element.trigger('change');
        // }

        
    });
    
}

function set_autocomplete_inputs(element){

    element.find('input.form-autocomplete').each(function(){
        let _this=this;
        let options={
            source: "search.php",
            minLength: 2,
            create: function( event, ui ) {
                let label=$(_this).val();
                let id=$(_this).parent().find('input[type=hidden]').val();

                // console.log(label,id);

                $(_this).data('default_item',{id:id, label:label});
            },
            focus: function( event, ui ) {
                $(_this).removeData('items');
                console.log('onfocus removed',$(_this).data('items'));
            },
            search: function( event, ui ) {
                $(_this).removeData('items');
                console.log('onsearch removed',$(_this).data('items'));
            },
            response: function( event, ui ) {
                $(_this).data('items', ui.content);
                console.log('onResponse', ui.content);
            },
            select: function( event, ui ) {
            //   console.log( "Selected: " + ui.item.value + " aka " + ui.item.id );

                if($(this).data('target_fields')){
                    let target_fields=$(this).data('target_fields').split('|');

                    console.log('TGT fields',target_fields);
                    console.log(ui.item);

                    for(let i=0;i<target_fields.length;i++){
                        console.log($(_this).closest('.autocomplete-wrap').find('.ac-fill-'+target_fields[i]));

                        $(_this).closest('.autocomplete-wrap').find('.ac-fill-'+target_fields[i]).val(ui.item[target_fields[i]]);
                    }

                }else{
                    $(_this).parent().find('input[type=hidden]').val(ui.item.id);
                }

                if($(_this).data('select_callback')){

                    // console.log($(_this).data('select_callback'));

                    window[$(_this).data('select_callback')](ui.item);
                }

                $(_this).removeData('items');


              
            },
            change: function (event, ui) {
                
                if($(_this).val() && !ui.item && (typeof $(_this).data('items')==='undefined')){
                    //waiting for results
                    let val=$(_this).val();
                    $(_this).val('');
                    console.log('waiting for the results');
                    setTimeout(function(){
                        $(_this).trigger('focus');
                        $(_this).autocomplete('search', val);
                        $(_this).val(val);
                        
                    },300)
                      
                    return;
                }

                if(!ui.item && $(_this).data('items') && $(_this).data('items').length){
                    //try manually select if match
                    let val=$(_this).val().trim();
                    let item =$(_this).data('items')[0];

                    let item_val=item.label.trim();
                    if($(_this).data('manual_select_field')){
                        item_val=item[$(_this).data('manual_select_field')].trim();
                    }

                    if(val.toLowerCase()==item_val.toLowerCase()){
                        console.log('Manual match!');
                        $(this).data('ui-autocomplete')._trigger('select', 'autocompleteselect', {item:item});
                        return;
                    }
                }


                if(!ui.item && $(_this).data('allow_insert')==1 && $(_this).val()){

                    console.log(ui);

                    if($(_this).data('insert_clear_fields')){
                        let target_fields=$(_this).data('insert_clear_fields').split('|');

                        for(let i=0;i<target_fields.length;i++){
                            $(_this).closest('.autocomplete-wrap').find('.ac-fill-'+target_fields[i]).val('');
                        }

                    }

                    if($(_this).data('unselect_callback')){
                        window[$(_this).data('unselect_callback')]();
                    }

                    if($(_this).data('insert_handler')){
                        window[$(_this).data('insert_handler')]($(_this));
                    }else{
                        bootbox.alert('New record will be added');
                    }
                    
                }else{
                    if(!ui.item){
                        if(d_item=$(_this).data('default_item')){
                            $(_this).val(d_item.label);
                            $(_this).parent().find('input[type=hidden]').val(d_item.id);
                        }else{
                            $(_this).val("");
                            $(_this).parent().find('input[type=hidden]').val('');
                        }

                        if($(_this).data('unselect_callback')){
                            window[$(_this).data('unselect_callback')]();
                        }

                        
                    }
                }

            }
        };


        let type=$(this).data('ac_type');
        
        switch(type){
            case 'owner':
                options.source=root_url+'owners/autocomplete';
                break;
            case 'captain':
                options.source=root_url+'crew/autocomplete?type=captain';
                break;
            case 'crew':
                options.source=root_url+'crew/autocomplete';
                break;
            case 'agency':
                options.source=root_url+'agencies/autocomplete';
                break;
            case 'agent':
                options.source=root_url+'agents/autocomplete';
                break;
            case 'client':
                options.source=root_url+'clients/autocomplete';
                break;
            case 'service_provider':
                options.source=root_url+'service_providers/autocomplete';
                break;
            default:
                options.source=root_url+type+'/autocomplete';
        }


        $(this).autocomplete(options);

    //     set_currency_input($(this)[0]);

    //     $(this).on('focus',function(){
    //         this.select();
    //     });
    });

    // element.find('input.currency-decimal').each(function(){
    //     set_currency_decimal_input($(this)[0]);
    // });
    
}
window.set_autocomplete_inputs=set_autocomplete_inputs;

function save_on_change(e){

    e.preventDefault();

    let el=$(this);
    if(el.hasClass('form-autocomplete')){
        el=$(this).parent().find('input[type=hidden]');
    }

    el.closest('.form-group').find('.help-block').remove();
    el.closest('.form-group').removeClass('has-error');

    console.log(el.prop('name'),el.val());

    let request={};
    request.form=el.closest('form')[0];
    request.submit_fields=[el.prop('name')];
    request.callback=function(response){
        console.log('save_on_change_response',response);
        if(response.status=='error'){
            let name=el.prop('name');
            el.closest('.form-group').addClass('has-error');
            if(response.response.errors && response.response.errors[name]){
                el.closest('.form-group').append('<p class="help-block">'+response.response.errors[name][0]+'</p>');
            }else{
                el.closest('.form-group').append('<p class="help-block">Invalid value</p>');
            }
            el.trigger('focus');

        }else{
            el.trigger('blur');
        }

    }

    
    submit_form(request);

}

function submit_form(request){

    let form_valid = $( request.form )[0].reportValidity();
    
    if(!form_valid){
        return false;
    }
    

    //https://stackoverflow.com/questions/21044798/how-to-use-formdata-for-ajax-file-upload
    //https://www.nicesnippets.com/blog/jquery-ajax-form-submit-with-formdata-example
    //https://stackoverflow.com/questions/50691938/patch-and-put-request-does-not-working-with-form-data

    // $.blockUI({ message: null, 
    // baseZ: 999999, css:{ zIndex:'999999'} }); 

    block_ui();

    // $.blockUI({ message: null});

    remove_form_errors(request.form);


    // Get form
    //let form = e.target;
    //var form = $('#modal-form-{{$action}} form')[0];
     
    // FormData object 
    let data = new FormData(request.form);
    
    let submit_fields=(request.submit_fields?request.submit_fields:[]); //submit only listed fields!
   
    if(submit_fields.length){
        let new_data=new FormData();
        
        for (const [key, value] of data) {
            if(submit_fields.indexOf(key)>=0 || key.indexOf('_')==0){
                new_data.append(key,value);
                new_data.append('_submit_fields[]',key);

            }
        }
        data=new_data;
    }



    //AutoNumeric option unformatOnSubmit: true handles it. 
    //unformatOnSubmit will only work if this function is called from form submit handler, otherwise need to get unformated value manually

    for (const [key, value] of data) {

        // console.log('indexOf', key, submit_fields.indexOf(key));

        // if(submit_fields.length && submit_fields.indexOf(key)<0 && key.indexOf('_')!=0){
        //     //unset key and continue
        //     console.log('delete', key);
        //     data.delete(key);
        //     continue;
        // }

        // console.log('key',key,'value',value);
        if($(request.form).find('input[type="checkbox"][name="'+key+'"]').length){
            let cb=$(request.form).find('input[type="checkbox"][name="'+key+'"]');
            let cb_value=cb.val();
            if(cb.is(':checked')){
                // console.log('cb checked', cb[0]);
                
            }else{
                console.log('cb NOT checked', cb.parent().find('input[type="hidden"]')[0]);
                cb_value=cb.parent().find('input[type="hidden"]').val();    //hidden field value
                //data.set(key,cb.parent().find('input[type="hidden"]').val());  
            }

            // console.log('cb value',cb_value);
            data.set(key,cb_value);

        }else if(
            $(request.form).find('input[name="'+key+'"]').hasClass('currency') 
            || $(request.form).find('input[name="'+key+'"]').hasClass('currency-decimal')
            || $(request.form).find('input[name="'+key+'"]').hasClass('percentage')
            ){
            let unformated_val=AutoNumeric.getNumericString($(request.form).find('input[name="'+key+'"]')[0]);
            // console.log('unformated_val',unformated_val);
            data.set(key,unformated_val);
        }
    }

    // for (const [key, value] of data) {
    //     console.log(key,value);
    // }

   


    let link = request.form.getAttribute('action');
    let method = request.form.getAttribute('method');
    //let _method = method;

    //if(data.get('_method')){
    //    _method=data.get('_method');
    //}


    //link='/test-patch';
    // method='PATCH';
    //data.set('_method',method);

    //link='/test-post';
    //method='POST';
    //data.set('_method',method);

    console.log(request.form);
    console.log(link);
    console.log(method);
    // console.log(_method);
    // console.log(data.get('from_date')+' - '+data.get('to_date'));
    // for (const [key, value] of data) {
    //     console.log(key,value);
    // }

    // return;

    
    $.ajax({
        url: link,
        type: method,
        //method: method,
        data: data,
        processData: false,
        contentType: false,
        dataType: 'json',

        // headers: {'X-Requested-With': 'XMLHttpRequest'},

        success:function(response){
            //$.unblockUI();
            unblock_ui();
            console.log(response);
            if (typeof request.callback === 'function') {

                request.callback({request:request, response:response, status:'success'});
            }

        },
        error: function(response) {
            $.unblockUI();
            console.log(response);
            console.log(response.responseJSON);

            if (typeof request.callback === 'function') {
                request.callback({request:request, response:response.responseJSON, status:'error'});
            }else{
                bootbox.alert(xhr.responseJSON.message);
            }
           
        },
    });
}

window.submit_form=submit_form;

function show_form_errors(form,errors){

    for (const [key, value] of Object.entries(errors)) {
        console.log(key,value);
        //convert from . naming to []

        if(key.indexOf('.')){
            let key_chunks=key.split('.');

            for(let i=0;i<key_chunks.length;i++){
                if(i==0){
                    key=key_chunks[i];
                }else{
                    key+='['+key_chunks[i]+']';
                }
            }
            console.log(key);
        }
        
        console.log($(form).find('[name="'+key+'"]'));
        
        $(form).find('[name="'+key+'"]').after('<p class="help-block">'+value[0]+'</p>');
        $(form).find('[name="'+key+'"]').closest('.form-group').addClass('has-error');
    }

}

window.show_form_errors=show_form_errors;

function remove_form_errors(form){
    $(form).find('.error-message').remove();
    $(form).find('.has-error .help-block').remove();
    $(form).find('.has-error').removeClass('has-error');
}

window.remove_form_errors=remove_form_errors;


function update_table_values(response){
    let t_id=response.response.handling_data.table_id;
    let r_id=response.response.handling_data.row_id;
    let r_color=response.response.row_color;
    let row=$('#'+t_id).find('#'+r_id);
    // console.log(row);

    console.log('row color class',r_color);

    if(typeof r_color!=='undefined' && r_color!=null){
        row.removeClass('table-info table-danger table-secondary table-warning table-success table-primary table-dark table-light table-black') ;
        row.addClass(r_color);
    }

    for (const [key, value] of Object.entries(response.response.display_data)) {
        //console.log(`${key}: ${value}`);

        if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            for (const [key2, value2] of Object.entries(value)) {
                // console.log('2. depth', 'KEY=',key2,' VALUE=',value2);

                let field=row.find('[data-field='+key+'-'+key2+']');
                // console.log('update_table_values',key,key2,field);
                if(field.length){
                    field.html(value2);
                }
            }

        }else{
            // console.log('1. depth', 'KEY=',key,' VALUE=',value);

            let field=row.find('[data-field='+key+']');
            // console.log('update_table_values',key,field);
            if(field.length){
                field.html(value);
            }

        }

        

    }

    success_color_animate(row);
}

window.update_table_values=update_table_values;


/////////////////////// MODAL FORM HANDLING //////////////////////


function modal_trigger_click(e){

    e.preventDefault();

    let modal_data=($(this).data('modal')?$(this).data('modal'):{});

    console.log('modal_data',modal_data);

    let url=($(this).data('modal_url')?$(this).data('modal_url'):modal_data.url);
    let callback='show_ajax_modal';
    if(modal_data.callback){
        callback=modal_data.callback;
    }
    let data={};
    if(modal_data.data){
        data=modal_data.data;
    }

    block_ui();

    $.ajax({
        url: url,

        method: 'POST',
    
        // The name of the callback parameter, as specified by the YQL service
        jsonp: 'callback',
        jsonpCallback: callback,
    
        // Tell jQuery we're expecting JSONP
        dataType: 'jsonp',

        // headers: {'X-Requested-With': 'XMLHttpRequest'},
    
        // Tell YQL what we want and that we want JSON
        data: data,
    
        // Work with the response
        success: function( response ) {
            console.log( 'success',response ); // server response

            unblock_ui();
        },
        error: function(xhr, ajaxOptions){
            bootbox.alert(xhr.responseJSON.message);
            unblock_ui();
        }
    }); 

    return false;

}
window.modal_trigger_click=modal_trigger_click;

function show_ajax_modal(response){

    console.log('show_ajax_modal',response);



    $('body').append(`
    <div class="modal fade ajax-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document" >
        <div class="modal-content">
          <div class="modal-header modal-header--sticky bg-primary text-white">
            <h5 class="modal-title"><span> </span></h5>
            <button class="close text-white" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body default">
           
          </div>
          <div class="modal-footer default">

            <button class="btn btn-secondary close-btn" type="button" data-dismiss="modal" onclick="ajax_modal_click(0);">Close</button>
            <button class="btn btn-primary save-btn" type="button" data-dismiss="modal" onclick="ajax_modal_click(1);">Save</button>
            
          </div>

          <div class="modal-script"></div>

        </div>
      </div>
    </div>
    `);



    $('.ajax-modal:last .modal-script').html('');

    $('.ajax-modal:last .modal-body').html(response.data.html);
    $('.ajax-modal:last .modal-title span').html(response.data.title);

    if(response.data.size){
        $('.ajax-modal:last .modal-dialog').attr('class','modal-dialog '+response.data.size);
    }else{
        $('.ajax-modal:last .modal-dialog').attr('class','modal-dialog');
    }

    if(response.data.hide_footer){
        $('.ajax-modal:last .modal-content>.modal-footer').hide();
    }else{
        $('.ajax-modal:last .modal-content>.modal-footer').show();
    }
    if(response.data.btn){
        if(response.data.btn.labels){
            $('.ajax-modal:last .close-btn').html(response.data.btn.labels.close);
            $('.ajax-modal:last .save-btn').html(response.data.btn.labels.save);
        }else{
            $('.ajax-modal:last .close-btn').html('Cancel');
            $('.ajax-modal:last .save-btn').html('Save');
        }

        if(response.data.btn.colors){
            $('.ajax-modal:last .close-btn').attr('class', function(i, c){
                return c.replace(/(^|\s)btn-\S+/g, ' btn-'+response.data.btn.colors.close);
            });
            $('.ajax-modal:last .save-btn').attr('class', function(i, c){
                return c.replace(/(^|\s)btn-\S+/g, ' btn-'+response.data.btn.colors.save);
            });
        }else{
            $('.ajax-modal:last .close-btn').attr('class', function(i, c){
                return c.replace(/(^|\s)btn-\S+/g, ' btn-secondary');
            });
            $('.ajax-modal:last .save-btn').attr('class', function(i, c){
                return c.replace(/(^|\s)btn-\S+/g, ' btn-primary');
            });
        }

    }

    if(response.data.request_data._set_handling){
        $('.ajax-modal:last form').append('<input type="hidden" name="_set_handling" value="'+response.data.request_data._set_handling+'">');
        
    }

    if(response.data.request_data._set_callback){
        $('.ajax-modal:last form').append('<input type="hidden" name="_set_callback" value="'+response.data.request_data._set_callback+'">');
        
    }
    

    $('.ajax-modal:last .modal-header').attr('class', function(i, c){
        return c.replace(/(^|\s)alert-\S+/g, ' alert-'+response.data.type);
    });
    $('.ajax-modal:last').modal('show');


    if(response.data.script){
        $('.ajax-modal:last .modal-script').html('<script>'+response.data.script+'<\/script>');
    }

    console.log('auto-modal-trigger count',$('.ajax-modal:last .auto-modal-trigger').length);

    $('.ajax-modal:last .auto-modal-trigger').on('click',modal_trigger_click);
    
}
window.show_ajax_modal=show_ajax_modal;

function hide_ajax_modal(){

    console.log('hide_ajax_modal');

    $('.ajax-modal:last').modal('hide');
    

}

window.hide_ajax_modal=hide_ajax_modal;

/////////////////////// END - MODAL FORM HANDLING //////////////////////


function number_to_currency(val){
    console.log('number_to_currency',val);

    //TODO proper formating
    val=val.toLocaleString("hr-HR");
    return val;
}
window.number_to_currency=number_to_currency;